// extracted by mini-css-extract-plugin
export default {"formContainer":"GoogleFormEmbed_formContainer__c5UlB"};